import Section from "./Section";

const PermissionListItem = ({ type, theme, ...props }) => {
  return type === "section" ? (
    <Section theme={theme} {...props} />
  ) : (
    <Section theme={theme} {...props} />
  );
};

export default PermissionListItem;
